import React, { useState } from 'react';
import styled from 'styled-components/macro';

import { distances, colors } from '../../styles/constants';
import Icon from '../../components/Icons';

const safeJsonStringify = (body: any | undefined) => {
    try {
        return body ? JSON.stringify(body, null, 2) : undefined;
    } catch {
        console.log('Failed JSON.stringify of', body);
        return body;
    }
};

const ExpandCollapseJson = (
    {
        label,
        json,
        background,
    }: {
        label: any;
        json: any;
        background?: string;
    }
) => {
    const [isExpanded, toggle] = useState(false);
    return (
        <WrapExpandCollapse>
            <LabelWrap onClick={() => toggle(!isExpanded)}>
                {label}
                <Icon
                    icon="caret_down"
                    fill={colors.text}
                    className={['clickable', isExpanded && 'flip'].filter((x) => x).join(' ')}
                ></Icon>
            </LabelWrap>
            {isExpanded && <Pre background={background}>{safeJsonStringify(json)}</Pre>}
        </WrapExpandCollapse>
    );
};

const WrapExpandCollapse = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const LabelWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    cursor: pointer;
    width: 100%;
    padding: 0 3px;

    &:hover {
        background: ${colors.interactiveBackgroundHover};
    }
`;

const Pre = styled.pre<{ background?: string }>`
    white-space: pre-wrap;
    background: ${(props) => props.background || colors.backgroundAlt};
    margin: 0;
    padding: ${distances.normal};
    overflow: scroll;
    width: 100%;
`;

export default ExpandCollapseJson;
